import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import BasicInfoTab from "./BasicInfo";
import LocationTab from "./LocationTab";
import RoomsAndSpaces from "./RoomsAndSpaces";
import PhotosAndVideos from "./PhotosAndVideos";
import Amenities from "./Amenities";
import Pricing from "./Price";
import Policies from "./Policy";
import Legal from "./Legal";
import RoomAvailability from "./RoomsAvailability";
import { useLocation, useNavigate } from "react-router-dom";
import SuccessModal from "../Modal/SuccessModal";
import API_BASE_URL from "../../config";
import NoSubscriptionModal from "../Modal/NoSubscriptionModal";

const TabWizard = () => {
  const basicInfoRef = useRef();
  const locationRef = useRef();
  const roomsRef = useRef();
  const roomsAvailabilityRef = useRef();
  const photosRef = useRef();
  const amenitiesRef = useRef();
  const policiesRef = useRef();
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();


  // Store stayId returned from BasicInfo API
  const [stayId, setStayId] = useState(null);

  const location = useLocation();

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [modalContent, setModalContent] = useState({
    title: "",
    message: "",
    confirmText: "",
    cancelText: ""
  });

  const [showNoSubModal, setShowNoSubModal] = useState(false);
  const token = localStorage.getItem("accessToken");

  // 🔹 Read stayId from URL param (edit mode)
  const params = new URLSearchParams(location.search);
  const stId = params.get("id") || "";

  const isEditMode = Boolean(stId); //. true if editing existing property

  useEffect(() => {
    const checkSubscription = async () => {
      if (!token) return; // not logged in

      try {
        const res = await axios.get(`${API_BASE_URL}auth/revenue/my-subscription`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!res.data.data) {
          // show modal if no active subscription
          setShowNoSubModal(true);
        }
      } catch (err) {
        console.error("Subscription check failed", err);
        setShowNoSubModal(true); // show modal on error
      }
    };

    checkSubscription();
  }, [token]);

  const tabs = [
    {
      id: "BasicInfo",
      label: "Basic Info",
      component: <BasicInfoTab ref={basicInfoRef} setStayId={setStayId} />,
    },
    {
      id: "Location",
      label: "Location",
      component: <LocationTab ref={locationRef} stayId={stayId} />,
    },
    { id: "RoomsAndSpaces", label: "RoomsAndSpaces", component: <RoomsAndSpaces ref={roomsRef} /> },
    { id: "RoomAvailability", label: "RoomsAvailability", component: <RoomAvailability ref={roomsAvailabilityRef} /> },
    { id: "Photos", label: "Photos", component: <PhotosAndVideos ref={photosRef} propStayId={stayId} /> },
    { id: "Amenities", label: "Amenities", component: <Amenities ref={amenitiesRef} propStayId={stayId} /> },

    // { id: "Pricing", label: "Pricing & Availability", component: <Pricing /> },
    { id: "Policies", label: "Policies", component: <Policies ref={policiesRef} propStayId={stayId} /> },
    { id: "Revenue Model", label: "Documents", component: <Legal /> },
    // { id: "Submit", label: "Submit", component: <div>Submit Content</div> },
  ];

  // const nextTab = async () => {
  //   try {
  //     if (tabs[activeIndex].id === "BasicInfo" && basicInfoRef.current) {
  //       const success = await basicInfoRef.current.submit();

  //       //. Only proceed if API succeeded
  //       if (success) {
  //         // If you still want to store stayId inside the component:
  //         const stayId = localStorage.getItem("stayId");
  //         if (stayId) setStayId(stayId);

  //         //. Now move to next tab (depends on your tab switching logic)
  //         setActiveIndex((prev) => prev + 1);
  //       } else {
  //         // API failed — stay on the same tab
  //         console.warn("Basic Info not saved — staying on current tab");
  //         return; // stop execution
  //       }
  //     }


  //     if (tabs[activeIndex].id === "Location" && locationRef.current) {
  //       const success = await locationRef.current.submit();
  //       if (success) {

  //         setActiveIndex((prev) => prev + 1);
  //       } else {
  //         console.warn("Location info not saved — staying on current tab");
  //         return;
  //       }
  //     }


  //     if (tabs[activeIndex].id === "RoomsAndSpaces" && roomsRef.current) {
  //       await roomsRef.current.submit();
  //     }
  //     if (tabs[activeIndex].id === "RoomAvailability" && roomsAvailabilityRef.current) {
  //       const success = await roomsAvailabilityRef.current.submit();
  //       if (!success) {
  //         console.warn("Room availability not saved — staying on current tab");
  //         return;
  //       } else {
  //         setActiveIndex((prev) => prev + 1);
  //         return; //. stop further execution to avoid double increment
  //       }
  //     }


  //     // Upload images for Photos tab
  //     if (tabs[activeIndex].id === "Photos" && photosRef.current) {
  //       await photosRef.current.submit();
  //     }
  //     // Submit selected amenities for Amenities tab
  //     if (tabs[activeIndex].id === "Amenities" && amenitiesRef.current) {

  //       await amenitiesRef.current.submit();
  //     }

  //     if (tabs[activeIndex].id === "Policies" && policiesRef.current) {
  //       await policiesRef.current.submit();
  //     }

  //     if (activeIndex < tabs.length - 1) setActiveIndex(activeIndex + 1);
  //   } catch (err) {
  //     console.error(err);
  //     alert("Failed to save data for this tab.");
  //   }
  // };

  const nextTab = async () => {
    try {
      const currentTab = tabs[activeIndex];

      // 🔹 BASIC INFO
      if (currentTab.id === "BasicInfo" && basicInfoRef.current) {
        const stayIdFromApi = await basicInfoRef.current.submit();

        if (!stayIdFromApi) {
          console.warn("Basic Info not saved — staying on current tab");
          return;
        }

        setStayId(stayIdFromApi);

        // ✅ Update URL with stayId
        navigate(`/upload-property?id=${stayIdFromApi}`, { replace: true });

        setActiveIndex((prev) => prev + 1);
        return;
      }

      // 🔹 LOCATION
      if (currentTab.id === "Location" && locationRef.current) {
        const success = await locationRef.current.submit();

        if (!success) {
          console.warn("Location info not saved — staying on current tab");
          return;
        }

        setActiveIndex((prev) => prev + 1);
        return;
      }

      // 🔹 ROOMS & SPACES
      if (currentTab.id === "RoomsAndSpaces" && roomsRef.current) {
        await roomsRef.current.submit();
        setActiveIndex((prev) => prev + 1);
        return;
      }

      // 🔹 ROOM AVAILABILITY
      if (currentTab.id === "RoomAvailability" && roomsAvailabilityRef.current) {
        const success = await roomsAvailabilityRef.current.submit();

        if (!success) {
          console.warn("Room availability not saved — staying on current tab");
          return;
        }

        setActiveIndex((prev) => prev + 1);
        return;
      }

      // 🔹 PHOTOS
      if (currentTab.id === "Photos" && photosRef.current) {
        await photosRef.current.submit();
        setActiveIndex((prev) => prev + 1);
        return;
      }

      // 🔹 AMENITIES
      if (currentTab.id === "Amenities" && amenitiesRef.current) {
        await amenitiesRef.current.submit();
        setActiveIndex((prev) => prev + 1);
        return;
      }

      // 🔹 POLICIES
      if (currentTab.id === "Policies" && policiesRef.current) {
        await policiesRef.current.submit();
        setActiveIndex((prev) => prev + 1);
        return;
      }

      // 🔹 DEFAULT FALLBACK
      if (activeIndex < tabs.length - 1) {
        setActiveIndex((prev) => prev + 1);
      }

    } catch (err) {
      console.error(err);
      alert("Failed to save data for this tab.");
    }
  };
  const prevTab = () => {
    if (activeIndex > 0) setActiveIndex(activeIndex - 1);
  };

  return (
    <section className="basicinfocontainer">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="infobxouter">
              <div className="dlsteptabsview">
                {/*. TAB HEADER */}
                <ul className="nav nav-tabs" role="tablist">
                  {tabs.map((tab, index) => (
                    <li className="nav-item" role="presentation" key={tab.id}>
                      <button
                        className={`nav-link ${activeIndex === index ? "active" : ""}`}
                        type="button"
                        role="tab"
                        aria-selected={activeIndex === index}
                        // 🔹 Allow all tabs if edit mode, else disable future tabs
                        disabled={!isEditMode && index > activeIndex}
                        onClick={() => {
                          if (isEditMode || index <= activeIndex) {
                            setActiveIndex(index);
                          }
                        }}
                      >
                        {tab.label}
                      </button>
                    </li>
                  ))}
                </ul>
                <div className="tab-content mt-3">
                  <div className="tab-pane fade show active" role="tabpanel">
                    {tabs[activeIndex].component}
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-between gap-3 mt-3 mt-md-4">
                {/* <button
                  className="default-btn gap-1"
                  onClick={prevTab}
                  disabled={activeIndex === 0}
                >
                  <i className="fa fa-caret-left m-0"></i>
                  <span className="p-0">Back</span>
                </button> */}
                {/* <button
                  className="theme-btn"
                  type="button"
                  onClick={nextTab}
                  disabled={activeIndex === tabs.length - 1}
                >
                  {activeIndex === tabs.length - 1 ? "Finish" : "Save & Continue"}
                </button> */}

                <button
                  className="default-btn gap-1"
                  onClick={prevTab}
                  disabled={activeIndex === 0}
                >
                  <i className="fa fa-caret-left m-0"></i>
                  <span className="p-0">Back</span>
                </button>
                {/* <button
                  className="theme-btn"
                  type="button"
                  onClick={async () => {
                    if (activeIndex === tabs.length - 1) {
                      // LAST TAB → Final submission
                      try {
                        if (tabs[activeIndex].id === "Policies" && policiesRef.current) {
                          await policiesRef.current.submit();
                        }

                        //. NAVIGATE AFTER FINISH
                        navigate("/my-properties");
                      } catch (err) {
                        console.error(err);
                        alert("Failed to submit the final tab.");
                      }
                    } else {
                      // Not last tab → normal next
                      nextTab();
                    }
                  }}
                >
                  {activeIndex === tabs.length - 1 ? "Finish" : "Save & Continue"}
                </button> */}

                <button
                  className="theme-btn"
                  type="button"
                  onClick={async () => {
                    if (activeIndex === tabs.length - 1) {
                      //. LAST TAB → show success popup
                      try {
                        if (tabs[activeIndex].id === "Policies" && policiesRef.current) {
                          await policiesRef.current.submit();
                        }

                        // 🔥 OPEN DYNAMIC SUCCESS MODAL
                        setModalContent({
                          title: "Property Submitted Successfully 🎉",
                          message:
                            "Your data has been saved successfully. If required, the admin will verify it first. Do you want to redirect to the property list page?",
                          confirmText: "Go to My Properties",
                          cancelText: "Stay Here"
                        });

                        setShowSuccessModal(true);

                      } catch (err) {
                        console.error(err);
                        alert("Failed to submit the final tab.");
                      }
                    } else {
                      // 👉 Normal tab flow
                      nextTab();
                    }
                  }}
                >
                  {activeIndex === tabs.length - 1 ? "Finish" : "Save & Continue"}
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
      <SuccessModal
        show={showSuccessModal}
        title={modalContent.title}
        message={modalContent.message}
        confirmText={modalContent.confirmText}
        cancelText={modalContent.cancelText}
        onConfirm={() => {
          setShowSuccessModal(false);
          navigate("/my-properties");
        }}
        onCancel={() => setShowSuccessModal(false)}
      />

      <NoSubscriptionModal
        show={showNoSubModal}
        onSubscribe={() => {
          setShowNoSubModal(false);
          navigate("/my-subscription");
        }}
        onClose={() => setShowNoSubModal(false)}
      />

    </section>
  );
};

export default TabWizard;
